import { HttpClient } from '@angular/common/http';
import { Injectable, ViewChild } from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';
import { ChartOptions } from 'src/app/_helpers/chartOptions';
import { Subject } from 'rxjs';
import { ParkingReport, ParkingReportRequest, RequestParameters } from './parking-report.model';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/_services';
import { Utils } from 'src/app/_helpers/utils';
import { environment } from 'src/environments/environment';
import { BookingModel } from 'src/app/_models/booking.model';

const URL = environment.api

@Injectable({
  providedIn: 'root'
})
export class ParkingReportService {
  
  @ViewChild("chart") chart: ChartComponent;

  parkingReports: ParkingReport[] = [];
  parkingBookings: BookingModel[] = [];

  filterDetailsSubject: Subject<any> = new Subject<any>();
  filterDetailsShowLoader: boolean;

  public chartOptions: Partial<ChartOptions>;
  defaultLocale: string;
  chartHeader: string;
  chartHeaderSize: string;
  entires: string;
  exits: string;
  noDataText: string;

  request: ParkingReportRequest = new ParkingReportRequest;
  requestParameters: RequestParameters = new RequestParameters;

  localePl = require("node_modules/apexcharts/dist/locales/pl.json");
  localeEn = require("node_modules/apexcharts/dist/locales/en.json");

  constructor(
    public translateServ: TranslateService,
    private http: HttpClient,
    private userServ: UserService,
  ) { }

  /** true - filter | false - clear filters */
  reloadFilter(value: boolean) {
    this.filterDetailsSubject.next(value);
  }

  getParkingReports(queryParams: ParkingReportRequest) { 
    return this.http.get<ParkingReport[]>(URL + "analitics", { params: Utils.httpParams(queryParams) });
  }

  async loadChart(
    data: ParkingReport[]
  ) {
    this.chartOptions = {
      series: [{
          name: this.translateServ.instant("ADMIN.PARKING.AMOUNT"),
          data: data?.map((item) => { return item?.total }),
        }
      ],
      chart: {
        height: 250,
        type: "bar",
        zoom: {
          enabled: false,
          type: 'x',  
          autoScaleYaxis: false,  
        },
        defaultLocale: this.userServ.getDefaultLanguage(),
        locales: [ this.localePl, this.localeEn ],
        toolbar: {
          tools: {
            download: false,
          }
        },
      },
      colors: ["#D60D8C", "#4285F4"],
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: 2,
      },
      title: {
        text: this.translateServ.instant(
          "ADMIN.PARKING.HEADER"
        ),
        align: "left",
        margin: 10,
        offsetX: 10,
        style: {
          fontSize: this.chartHeaderSize,
          fontWeight: 'bold',
        },
      },
      markers: {
        size: 0,
        hover: {
          sizeOffset: 6
        }
      },
      xaxis: {
        tickPlacement: 'on',
        categories: data.map((item) => { 
          return this.translateServ.instant("ADMIN.PARKING.CATEGORY." + item.status.toUpperCase()) 
        }),
      },
      grid: {
        row: {
          colors: ['#fff', '#f2f2f2']
        }
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'light',
          type: "horizontal",
          shadeIntensity: 0.25,
          gradientToColors: undefined,
          inverseColors: true,
          opacityFrom: 0.85,
          opacityTo: 0.85,
          stops: [50, 0, 100]
        },
      },
      noData: {
        text: this.translateServ.instant(
          "NO_DATA_TO_SHOW"
        ),
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          fontSize: '18px',
        }
      }
    }
  }

}
